const modelNodes = {
  initial: [
    0, 2, 3, 4, 5, 6, 21, 22, 23, 225, 226, 227, 770, 771, 772,
    784, 785, 786, 798, 799, 800, 808, 816,
  ],
  Deluxe: {
    nodes: [
      0, 2, 3, 4, 5, 6, 21, 22, 23, 225, 226, 227, 770, 771, 772,
      784, 785, 786, 798, 799, 800, 808, 816,
    ],
    heater: {
      Internal: {
        nodes: [
          253, 254, 255, 630, 631, 632, 640, 656, 657, 658, 889, 890, 891, 899,
          907,
        ],
        hide: [798, 799, 800, 808, 816],
        show: [784, 785, 786],
        upgrades: {
          "Cover Around Internal Heater": {
            nodes: [267, 268, 269],
          },
        },
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [670, 671, 672],
          },
        },
      },
      External: {
        Standard: {
          show: [784, 785, 786, 798, 799, 800, 808, 816],
          nodes: [982, 983, 984, 992],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1204, 1205, 1206, 1214, 1222],
              initial: [1102, 1103, 1104, 1112],
            },
            "90-Degree Heater Connections": {
              nodes: [353, 354, 355, 363],
              initial: [982, 983, 984, 992],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [379, 380, 381],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [578, 579, 580, 588, 596],
                  initial: [476, 477, 478, 486],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [1036, 1037, 1038],
            },
          },
        },
        Medium: {
          show: [784, 785, 786, 798, 799, 800, 808, 816],
          nodes: [1242, 1243, 1244, 1252],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1166, 1167, 1168, 1176, 1184],
              initial: [1076, 1077, 1078, 1086],
            },
            "90-Degree Heater Connections": {
              nodes: [327, 328, 329, 337],
              initial: [1242, 1243, 1244, 1252],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [393, 394, 395],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [540, 541, 542, 550, 558],
                  initial: [450, 451, 452, 460],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [1022, 1023, 1024],
            },
          },
        },
        Large: {
          show: [784, 785, 786, 798, 799, 800, 808, 816],
          nodes: [956, 957, 958, 966],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [1128, 1129, 1130, 1138, 1146],
              initial: [1050, 1051, 1052, 1060],
            },
            "90-Degree Heater Connections": {
              nodes: [298, 299, 300, 308],
              initial: [],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [407, 408, 409],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [502, 503, 504, 512, 520],
                  initial: [421, 422, 423, 431],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [1008, 1009, 1010],
            },
          },
        },
      },
      "External Integrated": {
        hide: [784, 785, 786],
        show: [],
        nodes: [
          35, 36, 37, 48, 183, 184, 185, 729, 730, 731, 742, 750,
        ],
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [185, 197, 198, 199],
          },
        },
      },
      "Pahlen Electric": {
        show: [798, 799, 800, 808, 816],
        nodes: [],
      },
    },
    interiorexterior: {
      liner: {
        nodes: [230, 231, 232],
      },
    },
    accessories: {
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [124, 125, 126, 134, 145, 156],
        },
      },
      lidCover: {
        Wooden: {
          nodes: [927, 928, 929],
        },
        Insulated: {
          nodes: [281, 282, 283],
        },
        Fibreglass: {
          nodes: [942, 943, 944],
        },
      },
      wooden: {
        "Mini Bar / Side Table": {
          nodes: [701, 702, 703],
        },
        "Stirring Paddle": {
          nodes: [829, 830, 831],
        },
        "Wide Bespoke Steps": {
          nodes: [81, 82, 83],
          initial: [225, 226, 227],
        },
        "Stainless Steel Straps": {
          fullRings: [211, 212, 213],
          simpleRings: [67,68,69],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [95, 96, 97, 105, 1268, 1269, 1270, 1278, 1286],
          },
          "2 LED Lights": {
            nodes: [95, 96, 97, 105, 1306, 1307, 1308, 1316, 1324],
          },
          "3 LED Lights": {
            nodes: [95, 96, 97, 105, 1268, 1269, 1270, 1278, 1286, 1306, 1307, 1308, 1316, 1324],
          },
        },
        "Combined Massage System": {
          nodes: [
            95, 96, 97, 105, 836, 837, 838, 846, 857, 865, 1382, 1383, 1384,
            1392, 1400, 1408,
          ],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [95, 96, 97, 105, 1482, 1483, 1484, 1492, 1500, 1508],
          },
          "2.2kW with 10 jets": {
            nodes: [95, 96, 97, 105, 1482, 1483, 1484, 1492, 1500, 1508, 1532, 1533, 1534, 1542, 1550, 1558],
          },
        },
        "Air Bubble System": {
          nodes: [95, 96, 97, 105, 1382, 1383, 1384, 1392, 1400, 1408, 1432, 1433, 1434, 1442, 1450, 1458],
        },
      },
    },
  },
  "Deluxe XL": {
    nodes: [
      0, 2, 1712, 1713, 1714, 1715, 1727, 1728, 1729, 1927,
      1928, 1929, 2457, 2458, 2459, 2486, 2487, 2488, 2500, 2501, 2502,
    ],
    heater: {
      External: {
        Standard: {
          show: [2486, 2487, 2488],
          nodes: [2578, 2579, 2580, 2588],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2800, 2801, 2802, 2810, 2818],
              initial: [2698, 2699, 2700, 2708],
            },
            "90-Degree Heater Connections": {
              nodes: [2049, 2050, 2051, 2059],
              initial: [],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2075, 2076, 2077],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2271, 2272, 2273, 2281, 2289],
                  initial: [2169, 2170, 2171, 2179],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2632, 2633, 2634],
            },
          },
        },
        Medium: {
          show: [1913, 1914, 1915, 2486, 2487, 2488],
          nodes: [2838, 2839, 2840, 2848],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2762, 2763, 2764, 2772, 2780],
              initial: [2672, 2673, 2674, 2682],
            },
            "90-Degree Heater Connections": {
              nodes: [2023, 2024, 2025, 2033],
              initial: [],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2089, 2090, 2091],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2233, 2234, 2235, 2243, 2251],
                  initial: [2143, 2144, 2145, 2153],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2618, 2619, 2620],
            },
          },
        },
        Large: {
          show: [2486, 2487, 2488],
          nodes: [2552, 2553, 2554, 2562],
          upgrades: {
            "External Heater Glass Door": {
              nodes: [2724, 2725, 2726, 2734, 2742],
              initial: [2646, 2647, 2648, 2656],
            },
            "90-Degree Heater Connections": {
              nodes: [1997, 1998, 1999, 2007],
              initial: [],
              flueDrain: {
                "Chimney Heat Guard": {
                  nodes: [2103, 2104, 2105],
                },
              },
              upgrades: {
                "External Heater Glass Door": {
                  nodes: [2195, 2196, 2197, 2205, 2213],
                  initial: [2117, 2118, 2119, 2127],
                },
              },
            },
          },
          flueDrain: {
            "Chimney Heat Guard": {
              nodes: [2604, 2605, 2606],
            },
          },
        },
      },
      "External Integrated": {
        nodes: [
          1741, 1742, 1743, 1751, 1885, 1886, 1887, 2419,
          2420, 2421, 2429, 2437,
        ],
        show: [],
        hide: [2486, 2487, 2488],
        flueDrain: {
          "Chimney Heat Guard": {
            nodes: [1899, 1900, 1901],
          },
        },
      },
      "Pahlen Electric": {
        show: [],
        nodes: [],
      },
    },
    accessories: {
      lidCover: {
        Wooden: {
          nodes: [2471, 2472, 2473],
        },
        Insulated: {
          nodes: [1983, 1984, 1985],
        },
        Fibreglass: {
          nodes: [1969, 1970, 1971],
        },
      },
      flueDrain: {
        "High-Flow Drain Tap": {
          nodes: [1821, 1822, 1823, 1831, 1839, 1847],
        },
      },
      wooden: {
        "Mini Bar / Side Table": {
          nodes: [2391, 2392, 2393],
        },
        "Wide Bespoke Steps": {
          nodes: [1781, 1782, 1783],
          initial: [1927, 1928, 1929],
        },
        "Stainless Steel Straps": {
          fullRings: [1913, 1914, 1915],
          simpleRings: [1767,1768,1769],
        },
      },
      electrical: {
        "LED Underwater Lighting": {
          "1 LED Light": {
            nodes: [1795, 1796, 1797, 1805, 3140, 3141, 3142, 3150, 3158],
          },
          "2 LED Lights": {
            nodes: [3178, 3179, 3180, 3188, 3196],
          },
          "3 LED Lights": {
            nodes: [3216, 3217, 3218, 3226, 3234],
          },
        },
        "Combined Massage System": {
          nodes: [
            1795, 1796, 1797, 1805, 2890, 2891, 2892, 2900, 2908, 2916, 2940,
            2941, 2942, 2950, 2958, 2966,
          ],
        },
        "Hydro Massage System": {
          "1.1kW with 6 jets": {
            nodes: [1795, 1796, 1797, 1805, 3040, 3041, 3042, 3050, 3058, 3066],
          },
          "2.2kW with 10 jets": {
            nodes: [1795, 1796, 1797, 1805, 3040, 3041, 3042, 3050, 3058, 3066, 3090, 3091, 3092, 3100, 3108, 3116],
          },
        },
        "Air Bubble System": {
          nodes: [1795, 1796, 1797, 1805, 2940, 2941, 2942, 2950, 2958, 2966, 2990, 2991, 2992, 3000, 3008, 3016],
        },
      },
    },
  },
};

export default modelNodes;
